import React from 'react';
import { Box, makeStyles, TableRow, TableCell } from '@material-ui/core';
import BodyText from './BodyText';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
const useStyles = makeStyles(() => ({
	optionsIcon: {
		height: 25,
		width: 25,
		backgroundColor: '#FDE8EE',
		// padding: 3,
		borderRadius: '50%',
	},
	tableCell: {
		fontSize: 12,
		// padding: 3,
		// fontWeight: 600,
	},
	img: {
		'& .MuiAvatar-img': {
			width: 30,
			height: 30,
		},
	},
}));
const DashboardTable2 = ({ item, rowIndex }) => {
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();

	return (
		<>
			<TableRow key={rowIndex}>
				<TableCell className={classes.tableCell}>{item.id}</TableCell>
				<TableCell className={classes.tableCell}>{item.type}</TableCell>
				<TableCell className={classes.tableCell}>{item.cart_id}</TableCell>
				<TableCell className={classes.tableCell}>{item.doj}</TableCell>
				<TableCell className={classes.tableCell}>{item.commission}</TableCell>
				<TableCell className={classes.tableCell}>{item.markup}</TableCell>
				<TableCell className={classes.tableCell}>{item.amount}</TableCell>
				<TableCell className={classes.tableCell}>{item.avail_bal}</TableCell>
				<TableCell className={classes.tableCell}>{item.payment_type}</TableCell>
				<TableCell className={classes.tableCell}>{item.date}</TableCell>
				<TableCell className={classes.tableCell}>{item.hold_status}</TableCell>
				<TableCell className={classes.tableCell}>
					{item.trans_section}
				</TableCell>
				<TableCell className={classes.tableCell}>{item.description}</TableCell>
			</TableRow>
		</>
	);
};

export default DashboardTable2;
